// lib/api/config.ts

const _API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:8090";

// 공통 타입 정의
export interface PaginationParams {
  page?: number;
  size?: number;
  sort?: string;
  direction?: 'asc' | 'desc';
}

export interface PaginationResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}

// API 엔드포인트
export const API_ENDPOINTS = {
  // Auth
  AUTH: {
    LOGIN: "/api/auth/login",
    LOGOUT: "/api/auth/logout",
    REFRESH: "/api/auth/refresh",
    ME: "/api/auth/me",
  },

  // Admin
  ADMIN: {
    LIST: "/api/admins",
    DETAIL: (id: number) => `/api/admins/${id}`,
    CREATE: "/api/admins",
    UPDATE: (id: number) => `/api/admins/${id}`,
    DELETE: (id: number) => `/api/admins/${id}`,
    CHECK_ID: "/api/admins/check-userid",
    SEARCH: "/api/admins/search",
  },

  // User (기존 시스템용)
  USER: {
    LIST: "/api/users",
    DETAIL: (id: number) => `/api/users/${id}`,
    CREATE: "/api/users",
    UPDATE: (id: number) => `/api/users/${id}`,
    DELETE: (id: number) => `/api/users/${id}`,
  },

  DEVICE: {
    LIST: "/api/devices",
    DETAIL: (id: number) => `/api/devices/${id}`,
    CREATE: "/api/devices",
    UPDATE: (id: number) => `/api/devices/${id}`,
    DELETE: (id: number) => `/api/devices/${id}`,
    CHECK_ID: "/api/devices/check-id",
    SEARCH: "/api/devices/search",
    UPLOAD_PHOTO: "/api/devices/photos",
    DELETE_PHOTO: (id: number) => `/api/devices/photos/${id}`,
    STATS: "/api/devices/stats",
    BY_REGION: (regionCode: string) => `/api/devices/region/${regionCode}`,
    EXCEL_DOWNLOAD: "/api/devices/excel",
    EXCEL_UPLOAD: "/api/devices/excel-upload",
    UPDATE_INSTALLATION: (id: number) => `/api/devices/${id}/installation`,
    UPDATE_STATUS: (id: number) => `/api/devices/${id}/status`,
    REGIONS: "/api/regions",
    REGION_DETAIL: (code: string) => `/api/regions/${code}`,
  },
  DATA_CRITERIA: {
    LIST: "/api/data-criteria",
    CREATE: "/api/data-criteria",
    BY_TYPE: (type: string) => `/api/data-criteria/type/${type}`,
    UPDATE: (id: number) => `/api/data-criteria/${id}`,
    DELETE: (id: number) => `/api/data-criteria/${id}`,
    BULK_UPDATE: "/api/data-criteria/bulk-update",
    UPDATE_ACTIVE: (id: number) => `/api/data-criteria/${id}/active`,
    UPDATE_ACTIVE_BY_TYPE: (type: string) => `/api/data-criteria/type/${type}/active`,
  },

  // Notice
  NOTICE: {
    LIST: "/api/notices",
    DETAIL: (id: number) => `/api/notices/${id}`,
    CREATE: "/api/notices",
    UPDATE: (id: number) => `/api/notices/${id}`,
    DELETE: (id: number) => `/api/notices/${id}`,
    TOGGLE_FIXED: (id: number) => `/api/notices/${id}/fixed`,
    DELETE_ATTACHMENT: (attachmentId: number) => `/api/notices/attachments/${attachmentId}`,
    DOWNLOAD_ATTACHMENT: (attachmentId: number) => `/api/notices/attachments/${attachmentId}/download`,
    FIXED_LIST: "/api/notices/fixed",
    RECENT_LIST: "/api/notices/recent",
    STATS: "/api/notices/stats",
    UPLOAD_IMAGE: "/api/notices/upload-image",
  },
} as const;
